import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import './BrowserTop.css';
import { useNavigate, useLocation } from 'react-router-dom';
import AddAccess from '../Util/AddAccess';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, topMessageAtom, isAuthLoadedAtom, pageAtom } from '../../State';
import { getImagePath } from '../Util/utils';
import DataModel from '../Util/DataModel';

export default function DownloadApp({ showError, setShowError }) {
  const navigate = useNavigate(); //リダイレクト用
  const { t } = useTranslation();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);
  const [isSent, setIsSent] = useState(false);
  //もっとを選択
  const close = (e) => {
    setShowError(null);
  };

  //背景をタップ時
  const tapBack = () => {
    setPageState('main');
  };

  //背景をタップ時
  const tapSend = async () => {
    setIsSent(true);
    let result = await DataModel.downloadAppRequest();
    if (result != null) {
    } else {
    }
  };

  return (
    <>
      <>
        <div id="backWrap" onClick={tapBack} style={{ opacity: '1' }}></div>
        <div id="nftDetailFlex">
          <div id="downloadAppWrap">
            <div className="downloadAppTitle">{t('mypage.Download Desktop App')}</div>
            <img src={getImagePath() + '/icons/downloadAppIcon.png'} />
            <div className="downloadAppBody">{t('mypage.Currently available only...')}</div>
            {isSent ? (
              <div className="downloadAppThanks">Thank you!</div>
            ) : (
              <button onClick={tapSend}>{t('mypage.Send Request')}</button>
            )}
          </div>
        </div>
      </>
    </>
  );
}
